import React from "react";

import "./project.css";

//DIsney - plus clone

import dis1 from "../img/disney/dis1.png";
import dis2 from "../img/disney/dis2.png";

import dis3 from "../img/disney/dis3.png";

import dis4 from "../img/disney/dis4.png";

import dis5 from "../img/disney/dis5.png";

//netflix clone

import net1 from "../img/netflix/net1.png";
import net2 from "../img/netflix/net2.png";
import net3 from "../img/netflix/net3.png";
//import net4 from "../img/netflix/net4.png";

//artistic clone
import art1 from "../img/art/art1.png";
import art2 from "../img/art/art2.png";
import art3 from "../img/art/art3.png";

//import Google-Search engine App

import g from "../img/google-clone/g.png";
import g1 from "../img/google-clone/g1.png";
import g2 from "../img/google-clone/g2.png";
import g3 from "../img/google-clone/g3.png";
import g4 from "../img/google-clone/g4.png";
import g5 from "../img/google-clone/g5.png";

//import Google Calendar app
import Ss from "../img/google-cal/Ss.png";
import Ss1 from "../img/google-cal/Ss1.png";
import Ss2 from "../img/google-cal/Ss2.png";

//import Expense tracker
import pic from "../img/expense-tracker/pic.png";
import pic1 from "../img/expense-tracker/pic1.png";
import pic2 from "../img/expense-tracker/pic2.png";
import pic3 from "../img/expense-tracker/pic3.png";

// Movie Information App

import Projects from "./projects";

class Portfolio extends React.Component {
  constructor() {
    super();
    this.state = {
      projects: [
        {
          title: "Disney Plus clone",
          webLink: "https://ashish-disney-plus.netlify.app",

          githubLink: "",
          description:
            "Clone of Disney Plus with signin authentication using firebase deployed over netlify.",
          stack: [
            "ReactJs",
            "Redux",
            "TMDB API",
            "NodeJs",
            "Javascript",
            "Firebase",
            "Netlify",
          ],
          image: dis1,
          image1: dis2,
          images: [dis3, dis4, dis5],
          dataLightbox: "gallery-DisneyCloneapp",
          type: "web-app",
        },
        {
          title: "Netflix Clone",
          webLink: "https://sasta-netflix.netlify.app",
          githubLink: "https://github.com/ashish-singh-au3/apps",
          description:
            "Clone of Netflix Ui with real time updates of shows/movies on every refresh.",
          stack: [
            "ReactJs",
            "Redux",
            "TMDB API",
            "NodeJs",
            "Material Ui",
            "CSS",
            "Bootstrap",
          ],
          image: net1,
          image1: net2,
          images: [net3],
          dataLightbox: "netflix-clone",
        },

        {
          title: "Google Clone",
          webLink:
            "https://github.com/ashish-singh-au3/Google-search-engine-clone",

          githubLink: "",
          description:
            "Google clone is exactly similar to real time Google search engine where you can search anything as you do in Google",
          stack: [
            "ReactJs",
            "Redux",
            "Google Developers API",
            "NodeJs",
            "Javascript",
            "Material-UI",
            "CSS",
          ],
          image: g,
          image1: g1,
          images: [g2, g3, g4, g5],
          dataLightbox: "gallery-GoogleCloneAPp",
          type: "web-app",
        },
        {
          title: "Artistic",
          webLink: "https://artistic-app.netlify.app",
          githubLink: "",
          description: "Marketplace for different types of Art items.",
          stack: [
            "HTML/CSS",
            "ReactJs",
            "NodeJs",
            "Redux",
            "Bootstrap",
            "Material Ui",
            "Netlify",
          ],
          image: art1,
          image1: art2,
          images: [art3],
          dataLightbox: "gallery-Artistic",
          type: "web-app",
        },
        {
          title: "Expense-Tracker App",
          githubLink:
            "https://github.com/ashish-singh-au3/My-Expense-Tracker-App",
          description: "Manage your expenses in just one go",
          stack: [
            "HTML/CSS",
            "ReactJs",
            "NodeJs",
            "Redux",
            "React Hooks",
            "Bootstrap",
            "Context API",
          ],
          image: pic,
          image1: pic1,
          images: [pic2, pic3],
          dataLightbox: "gallery-expenseTracker",
          type: "web-app",
        },
        {
          title: "Google-Calendaar App Clone",
          githubLink:
            "https://github.com/ashish-singh-au3/Google-calendar-clone",
          description:
            "Clone of google calendar app where you can View/Scroll/Add/Delete/Update an event",
          stack: ["ReactJs", "Redux", "NodeJs", "Materialize CSS"],
          image: Ss,
          image1: Ss1,
          images: [Ss2],
          dataLightbox: "gallery-google-cal",
          type: "web-app",
        },
      ],
    };
  }
  render() {
    return (
      <section id="work" className="portfolio-mf sect-pt4 route">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="title-box text-center">
                <h3
                  className="title-a s-port "
                  style={{ fontFamily: "Solway" }}
                >
                  Projects
                </h3>
                <div className="line-mf"></div>
                <br />
                <br />
              </div>
              {/* <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center'  }} >
                    <div>All</div>
                    <div>Website</div>
                    <div>Native Apps</div>
                  </div> */}
            </div>
          </div>

          <Projects projects={this.state.projects} type="All" />
        </div>
      </section>
    );
  }
}

export default Portfolio;
